// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8979) return "static/chunks/8979.1b73e70449025791.js";
	if (chunkId === 1360) return "static/chunks/1360.3064550762c91d2b.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"277":"54a60aa6","5004":"70e0d97a"}[chunkId] || chunkId) + "-" + {"277":"eb63a38e92fbb00b","2037":"2424ef1534f7bcb2","3241":"0d25d1653cfc690f","3646":"599659459ee9d151","5004":"cd2dde983337eb24","5914":"a95e0c686c2ba29f","8740":"c7acd9be2c0c8a02"}[chunkId] + ".js";
};